import React, { FC, useEffect, useRef, useState } from "react";
import "./submissionDetails.scss";
import { Divider, Modal, Table } from "antd";
import closeIcon from "../../../../assets/icons/close.svg";

import ActivityReportsService from "../../../../services/ReportsService/ActivityReports.service";
import { ActivityDetailsModel } from "../../../../models/ReportsModel/activity.model";




interface SubmissionDetailsProps {
  visible: boolean;
  setVisible: Function;
  setCurrentContent: Function;
  content: any;
}

const SubmissionDetails: FC<SubmissionDetailsProps> = (props) => {
  const { visible, setVisible, content, setCurrentContent } = props;

  const [activityDetails, setActivityDetails] = useState<ActivityDetailsModel[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  const fetchStudentDetails = () => {
    setLoading(true)
    ActivityReportsService.fetchActivitySubmissionDetails(
      { ActivityId: content?.activityId },
      (details) => {
        setActivityDetails(details);
        setLoading(false)
      },
      () => { },
      () => {
        setLoading(false);
      }
    );
  }



  useEffect(() => {
    if (content?.activityId) {
      fetchStudentDetails()
    }
  }, [visible]);


  return (
    <Modal
      title={null}
      centered
      visible={visible}
      onCancel={() => {
        setVisible(false)
        setCurrentContent("")
        setActivityDetails([])
      }}
      footer={null}
      // className="board-form__modal video-content__modal"
      closeIcon={<img src={closeIcon} alt="" />}
      width={1000}
    >

      <div className="board-form__header">
        <div className="board-form__title">{content?.activityName}</div>
      </div>
    
        <Table
          bordered
          dataSource={activityDetails}
          columns={[
            {
              title: 'Name',
              dataIndex: 'studentName',
              key: 'name',
            },
            {
              title: 'Section',
              dataIndex: 'sectionName',
              key: 'sectionName',
            },
            {
              title: 'Subject',
              dataIndex: 'subjectName',
              key: 'subjectName',
            },
            {
              title: 'Max Points',
              dataIndex: 'maxPoints',
              key: 'maxPoints',
            },

            {
              title: 'Points',
              dataIndex: 'points',
              key: 'points',
            },
            {
              title: 'TurnIn Count',
              dataIndex: 'turnInCount',
              key: 'turnInCount',
            },


          ]}
          pagination={{ defaultPageSize: 10 }}
          loading={loading}
        />
    </Modal>
  );
};

export default SubmissionDetails;
